import { useMemo, useState } from "react";
import Pagination from "../../components/Pagination/Pagination";
import { TableBody } from "../TablesBasePage/TableBody";
import { TableHeader } from "../TablesBasePage/TableHeader";
import "../TablesBasePage/TablesBasePage.scss";

const bohrkronenHeaderDefinitions = {
  header: [
    {
      columns: [
        { filtered: true, disabled: true },
        {
          span: 2,
          translationKey: "drillBits.claydrillbit",
          translationNamespace: "translation",
          filtered: true,
          disabled: false,
        },
        {
          span: 2,
          translationKey: "drillBits.crosscutdrillbit",
          translationNamespace: "translation",
          filtered: true,
          disabled: false,
        },
        {
          span: 2,
          translationKey: "drillBits.carbidedrillbit",
          translationNamespace: "translation",
          filtered: true,
          disabled: false,
        },
      ],
    },
    {
      columns: [
        {
          disabled: true,
          filtered: false,
          type: "string",
          path: "tragglied_name",
          translationKey: "tables.bohrkronen.tragglied_name",
          translationNamespace: "tables",
        },
        {
          disabled: false,
          filtered: false,
          type: "array",
          path: "bindiger_boden.standard",
          translationKey: "drillBits.standard",
          translationNamespace: "translation",
        },
        {
          disabled: false,
          filtered: false,
          type: "array",
          path: "bindiger_boden.adapter",
          translationKey: "drillBits.withAdapter",
          translationNamespace: "translation",
        },
        {
          disabled: false,
          filtered: false,
          type: "array",
          path: "nichtbindiger_boden.standard",
          translationKey: "drillBits.standard",
          translationNamespace: "translation",
        },
        {
          disabled: false,
          filtered: false,
          type: "array",
          path: "nichtbindiger_boden.adapter",
          translationKey: "drillBits.withAdapter",
          translationNamespace: "translation",
        },
        {
          disabled: false,
          filtered: false,
          type: "array",
          path: "fels.standard",
          translationKey: "drillBits.standard",
          translationNamespace: "translation",
        },
        {
          disabled: false,
          filtered: false,
          type: "array",
          path: "fels.adapter",
          translationKey: "drillBits.withAdapter",
          translationNamespace: "translation",
        },
      ],
    },
    {
      columns: [
        {
          disabled: true,
          filtered: false,
        },
        {
          disabled: false,
          filtered: false,
          translationKey: "drillBits.standard_f",
          translationNamespace: "translation",
        },
        {
          disabled: false,
          filtered: false,
          translationKey: "drillBits.withAdapter_f",
          translationNamespace: "translation",
        },
        {
          disabled: false,
          filtered: false,
          translationKey: "drillBits.standard_f",
          translationNamespace: "translation",
        },
        {
          disabled: false,
          filtered: false,
          translationKey: "drillBits.withAdapter_f",
          translationNamespace: "translation",
        },
        {
          disabled: false,
          filtered: false,
          translationKey: "drillBits.standard_f",
          translationNamespace: "translation",
        },
        {
          disabled: false,
          filtered: false,
          translationKey: "drillBits.withAdapter_f",
          translationNamespace: "translation",
        },
      ],
    },
  ],
};

export default function Bohrkronen({ functions: bohrkronenFunctions }) {
  const [currentPage, setCurrentPage] = useState(1);
  let pageSize = 20;
  const { isLoading, data: elements } = bohrkronenFunctions.GetAll();

  const currentTableData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    let res = elements?.slice(firstPageIndex, lastPageIndex);
    if (res?.length === 0 && currentPage !== 1) setCurrentPage(currentPage - 1);
    return res;
  }, [pageSize, currentPage, elements]);

  if (isLoading) return <p>loading...</p>;

  return (
    <>
      <div className="table-responsive">
        <table className="table table-striped table-hover">
          {!isLoading && (
            <>
              <TableHeader headerDefs={bohrkronenHeaderDefinitions} />
              <TableBody
                columns={bohrkronenHeaderDefinitions.header[1].columns}
                currentTableData={currentTableData}
                functions={bohrkronenFunctions}
              />
            </>
          )}
        </table>
      </div>
      {elements && (
        <Pagination
          className="pagination-bar"
          currentPage={currentPage}
          totalCount={elements?.length}
          pageSize={pageSize}
          onPageChange={(page) => setCurrentPage(page)}
        />
      )}
    </>
  );
}
